import React from 'react';
import type {PathNode} from '../../types/directory';
import './index.scss';

interface BreadcrumbProps {
  segments: PathNode[];
  onClick: (node: PathNode) => void;
}

export function Breadcrumb({segments, onClick}: BreadcrumbProps) {
  return (
    <div className="drive-breadcrumb">
      {segments.map((item: any, index: number) => {
        const isLast = index === segments.length - 1;

        return (
          <React.Fragment key={item.id}>
              <span
                className={isLast ? 'drive-breadcrumb__item drive-breadcrumb__item--active' : 'drive-breadcrumb__item'}
                onClick={() => {
                  if (!isLast) onClick(item);
                }}
              >
              {item.name}
            </span>

            {!isLast && (
              <span className="drive-breadcrumb__separator">/</span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
